import React from 'react'
import Helmet from 'react-helmet'
import { injectGlobal } from 'styled-components'
import { Provider, Relative, Flex } from 'rebass'
import { endsWith, trimEnd } from 'lodash'
import { navigateTo } from 'gatsby-link'

function trimSuffix(toTrim, trim) {
  if (!toTrim || !trim) {
    return toTrim
  }
  var index = toTrim.lastIndexOf(trim)
  if (index === -1 || index + trim.length !== toTrim.length) {
    return toTrim
  }
  return toTrim.substring(0, index)
}

injectGlobal`
  * { box-sizing: border-box; }
  body { 
    margin: 0; 
    font-family: sans-serif;
  }
  a {
    box-shadow: none;
  }
`

const theme = {
  colors: {
    green: '#4BC169',
  },
}

import Navbar from '../components/Navbar'
import Globe from '../components/Globe'

class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      language: endsWith(props.location.pathname, '/fr') ? 'french' : 'english',
    }
    this.switchLang = this.switchLang.bind(this)
  }

  switchLang() {
    console.log(this.props.location.pathname)

    if (typeof window !== 'undefined') {
      endsWith(this.props.location.pathname, '/fr')
        ? navigateTo(`${trimSuffix(this.props.location.pathname, '/fr')}/en`)
        : navigateTo(
            `${
              endsWith(this.props.location.pathname, '/en')
                ? trimSuffix(this.props.location.pathname, '/en')
                : trimSuffix(this.props.location.pathname, '/')
            }/fr`
          )
    }

    this.setState(prevState => ({
      language: prevState.language === 'english' ? 'french' : 'english',
    }))
  }

  render() {
    const { children, data, location } = this.props
    const { language } = this.state

    return (
      <Provider theme={theme}>
        <Helmet title="The Nature of Cities — Summit" />
        <Navbar
          menu={data.menu}
          menuFr={data.menuFr}
          location={location}
          switchLang={this.switchLang}
          language={language}
          {...data.header.acf}
        />
        <Relative>
          <Flex
            flexDirection={
              location.pathname === '/' ||
              location.pathname === '/en' ||
              location.pathname === '/en/' ||
              location.pathname === '/fr' ||
              location.pathname === '/fr/'
                ? 'column'
                : 'row'
            }
            justify="center"
            align="flex-start"
            style={{
              marginTop: -1,
              background:
                'linear-gradient(to bottom, rgba(75, 193, 105, 1), rgba(75, 193, 105, 0))',
            }}
          >
            <div style={{ flexGrow: 1, maxWidth: '60rem' }}>
              {children({ ...this.props, language: language })}
            </div>
            <Globe
              coords={data.dataJson.coords}
              visitorCoords={data.allAirtableundefined.edges}
              isHome={
                location.pathname === '/' ||
                location.pathname === '/en' ||
                location.pathname === '/en/' ||
                location.pathname === '/fr' ||
                location.pathname === '/fr/'
              }
              location={location.pathname}
            />
          </Flex>
        </Relative>
        {/* location.pathname !== '/' && <Footer /> */}
      </Provider>
    )
  }
}

export default TemplateWrapper

export const pageQuery = graphql`
  query layoutTestQuery {
    dataJson {
      id
      coords
    }
    allAirtableundefined {
      edges {
        node {
          id
          Lat
          Lng
          Amount
        }
      }
    }
    menu: wordpressWpApiMenusMenusItems(wordpress_id: { eq: 2 }) {
      id
      name
      items {
        order
        title
        url
        object
        object_slug
      }
    }
    menuFr: wordpressWpApiMenusMenusItems(wordpress_id: { eq: 10 }) {
      id
      name
      items {
        order
        title
        url
        object
        object_slug
      }
    }
    header: wordpressPage(id: { eq: "1db040a0-86e7-5e01-a731-2e6b619d5515" }) {
      title
      acf {
        tagline
        rotating_images {
          image {
            localFile {
              id
              childImageSharp {
                id
                sizes(maxWidth: 3000) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js